import {
  AppButton,
  AppRadioBox,
  AppTextField,
  AppTextArea,
  AppSelectBox,
  AppUploadBlock,
  AppSwitchBox,
} from 'components';
import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import UserDropDownMultiple from 'components/molecules/UserDropDownMultiple';
import SelectCoursesModal from './SelectCourseModal';
import MultiplePlanSelector from 'components/molecules/MultiplePlanSelector';
import useUserRoleList from 'hooks/API/GET/useUserRoleList';

function NotificationManageSection({ handleNotification, preloadedData = {} }) {
  const queryParams = `?mode=dropdown`;
  const { data } = useUserRoleList({ enabled: true, queryParams });
  const [title, handleTitle] = useState('');
  const [shortTitle, handleShortTitle] = useState('');
  const [description, handleDescription] = useState('');
  const [EST, handleEST] = useState('');
  const [ES, handleES] = useState('');
  const [ESClass, handleESClass] = useState('');
  const [role, handleRole] = useState('');
  const [recipients, handleRecipients] = useState([]);
  const [imageData, handleImageData] = useState(null);
  const [toBeSendOn, handleToBeSendOn] = useState('');
  const [selectedCategory, handleSelectedCategory] = useState('');
  const [selectedUserType, handleUserType] = useState('');
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [isListed, setIsListed] = useState(false);

  const [notificationImageFullPath, setNotificationImageFullPath] = useState(null);
  const [imageDeleted, setImageDeleted] = useState(false);

  const [event, handleEvent] = useState('');
  const [eventKey, handleEventKey] = useState('');

  const [isCourseModalOpen, setIsCourseModalOpen] = useState(false);
  const [selectedCourses, setSelectedCourses] = useState([]);

  const [formErrors, setFormErrors] = useState([]);

  //Handling preloaded state
  const isEditMode = Boolean(preloadedData && preloadedData._id);

  useEffect(() => {
    if (!data?.data || !Array.isArray(data.data)) return;

    const studentRole = data.data.find((role) => role.key === 'STUDENT');

    if (studentRole?._id) {
      handleRole(studentRole._id);
    }
  }, [data]);

  useEffect(() => {
    if (!isEditMode) return;

    // Basic fields
    handleTitle(preloadedData.title || '');
    handleShortTitle(preloadedData.shortTitle || '');
    handleDescription(preloadedData.description || '');
    if (preloadedData.toBeSendOn) {
      const formattedDate = new Date(preloadedData.toBeSendOn).toISOString().slice(0, 16);

      handleToBeSendOn(formattedDate);
    }
    handleEvent(preloadedData.event || '');
    handleEventKey(preloadedData.eventKey || '');

    // Hierarchy
    handleEST(preloadedData.est || '');
    handleES(preloadedData.es || '');
    handleESClass(preloadedData.class || '');

    // Display / listing
    setIsListed(preloadedData.displayType === 'LISTED');

    // Recipients
    handleRecipients(preloadedData.recipients || []);

    // Image
    if (preloadedData.imageUrl) {
      setNotificationImageFullPath(preloadedData.imageUrl);
      handleImageData({ imageUrl: preloadedData.imageUrl });
    }

    // Selection type (USER / COURSE)
    if (preloadedData.targetUsers) {
      // setSelectionType(preloadedData.selectionType);

      if (
        preloadedData.targetUsers === 'all' ||
        preloadedData.targetUsers === 'specific' ||
        preloadedData.targetUsers === 'not-onboarded'
      ) {
        handleSelectedCategory('user');

        if (preloadedData.targetUsers === 'all') {
          handleUserType('all');
        }
        if (preloadedData.targetUsers === 'specific') {
          handleUserType('specific');
        }
        if (preloadedData.targetUsers === 'not-onboarded') {
          handleUserType('not-onboarded');
        }
      }

      // if (preloadedData.selectionType === 'COURSE_USERS') {
      //   handleSelectedCategory('course');
      //   handleSelectedCourseType(preloadedData.courses?.length ? 'selectedCourses' : 'allCourse');

      //   setSelectedCourses({
      //     ...INITIAL_SELECTED_COURSES,
      //     courses: preloadedData.courses || [],
      //   });
      // }
    }

    // Plans
    if (Array.isArray(preloadedData.plan)) {
      setSelectedPlans(preloadedData.plan);
    }
  }, [preloadedData]);

  function handleFormSubmission() {
    setFormErrors([]);
    // Convert local datetime-local string → Date
    const localDate = new Date(toBeSendOn);

    // Convert to ISO string (UTC) for backend
    const scheduledUTC = localDate.toISOString();

    const data = {
      est: EST,
      es: ES,
      class: ESClass,
      recipients: recipients,
      title: title,
      shortTitle: shortTitle,
      description: description,
      imageUrl: '',
      image: null,
      imageFullUrl: '',
      imageCaption: '',
      toBeSendOn: scheduledUTC,
      event: event,
      eventKey: eventKey,
      selectedAudience: selectedCategory,
      selectedUsers: selectedUserType,
      displayType: isListed ? 'listed' : 'not-listed',
      course: selectedCourses.flatMap((entry) => entry.courses.map((c) => c.value)),
      plan: selectedPlans.map((p) => p.value),
    };

    data.selectedUsers = selectedUserType;
    if (imageData && imageData.imageUrl) {
      data.imageUrl = imageData.imageUrl;
    }
    const validation = manageNotificationSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }
    console.log('🚀 ~ handleFormSubmission ~ data:', data);
    // return;
    handleNotification(data);
  }

const handleUserSelection = (type) => {
  handleUserType(type);
  handleRecipients([]);

  if (selectedCategory === 'course') {
    setSelectedCourses([]);
    setSelectedPlans([]);
  }
};

const handleCategoryChange = (category) => {
  handleSelectedCategory(category);
  handleUserType('');
  handleRecipients([]);
  setSelectedPlans([]);
  setSelectedCourses([]);
};

  const handleNotificationImageChange = ({ file, uploadedData }) => {
    handleImageData({
      imageUrl: uploadedData?.file || null,
    });
    setNotificationImageFullPath(
      uploadedData ? `${uploadedData.basePath}${uploadedData.file}` : null
    );
    setImageDeleted(false);
  };

const handleCourseModalConfirm = (data) => {
  setSelectedCourses((prev) => [...(Array.isArray(prev) ? prev : []), data]);
};

  const errors = checkForErrors(formErrors);
  const clearFieldError = (field) => {
    setFormErrors((prev) => prev.filter((err) => err.path?.[0] !== field));
  };

  const handleDeleteSelectedCourse = (index) => {
    setSelectedCourses((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        {/* Back Button */}
        <ul className="tab__menu">
          <li className="back">
            <Link to="/manage/notifications">
              <button className="btn-back">
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </Link>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          {/* Breadcrumb */}
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                {
                  label: 'Dashboard',
                  to: '/dashboard',
                },
                {
                  label: 'Notification',
                  to: '/manage/notifications',
                },
              ]}
              current="Add Notification"
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-5">
              {/* Header */}
              <div className="tab__contentMenu">
                <ul className="tab__contentMenu-list">
                  <li>
                    <h2 className="prime-head p-0 boldtitle text-nowrap">
                      {isEditMode ? 'Update Notification' : 'Add Notification'}
                    </h2>
                  </li>
                </ul>
              </div>

              <div className="row mt-4">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <label className="label d-block">Target Audience *</label>
                  <AppRadioBox
                    inputProps={{
                      name: 'category',
                      value: 'user',
                      checked: selectedCategory === 'user',
                      onChange: () => handleCategoryChange('user'),
                    }}
                    labelProps={{ label: 'User' }}
                  />
                  <AppRadioBox
                    inputProps={{
                      name: 'category',
                      value: 'course',
                      checked: selectedCategory === 'course',
                      onChange: () => handleCategoryChange('course'),
                    }}
                    labelProps={{ label: 'Course' }}
                  />
                </div>
                {selectedCategory === 'user' && (
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <label className="label d-block">Target User</label>
                    <AppRadioBox
                      inputProps={{
                        name: 'userType',
                        value: 'all',
                        checked: selectedUserType === 'all',
                        onChange: () => handleUserSelection('all'),
                      }}
                      labelProps={{ label: 'All Users' }}
                    />
                    <AppRadioBox
                      inputProps={{
                        name: 'userType',
                        value: 'specific',
                        checked: selectedUserType === 'specific',
                        onChange: () => handleUserSelection('specific'),
                      }}
                      labelProps={{ label: 'Select Users' }}
                    />
                    <AppRadioBox
                      inputProps={{
                        name: 'userType',
                        value: 'not-onboarded',
                        checked: selectedUserType === 'not-onboarded',
                        onChange: () => handleUserSelection('not-onboarded'),
                      }}
                      labelProps={{ label: 'Users Not Onboarded' }}
                    />
                  </div>
                )}

                {selectedCategory === 'course' && (
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <label className="label d-block">Target Course</label>
                    <AppRadioBox
                      inputProps={{
                        name: 'courseType',
                        value: 'all',
                        checked: selectedUserType === 'all',
                        onChange: () => handleUserSelection('all'),
                      }}
                      labelProps={{ label: 'Purchased atleast one course' }}
                    />
                    <AppRadioBox
                      inputProps={{
                        name: 'courseType',
                        value: 'specific',
                        checked: selectedUserType === 'specific',
                        onChange: () => handleUserSelection('specific'),
                      }}
                      labelProps={{ label: 'Select Course' }}
                    />
                    <AppRadioBox
                      inputProps={{
                        name: 'courseType',
                        value: 'not-onboarded',
                        checked: selectedUserType === 'not-onboarded',
                        onChange: () => handleUserSelection('not-onboarded'),
                      }}
                      labelProps={{ label: 'No Course Purchased' }}
                    />
                  </div>
                )}

                {selectedCategory === 'user' && selectedUserType === 'specific' && (
                  <>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                      <UserDropDownMultiple
                        enableAPI={!!role}
                        dependencies={{
                          query: `role=${role}`,
                        }}
                        value={recipients}
                        fieldErrors={errors['recipients']}
                        handleChange={(event) => handleRecipients(event)}
                      />
                    </div>
                  </>
                )}

                {selectedCategory === 'course' && selectedUserType === 'specific' && (
                  <>
                    <div className="col-lg-4 col-md-6 col-sm-12 mt-4">
                      <label className="d-block">Select Course</label>
                      <AppButton
                        variantClass="btn-primary"
                        onClick={() => setIsCourseModalOpen(true)}
                      >
                        Select Course
                      </AppButton>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 mt-4">
                      <MultiplePlanSelector
                        enableAPI={true}
                        isMulti={true}
                        values={selectedPlans}
                        handleChange={(selected) => setSelectedPlans(selected)}
                        dependencies={{ query: { status: 'active' } }}
                      />
                    </div>
                  </>
                )}
              </div>
              {selectedCategory === 'course' &&
                selectedUserType === 'specific' &&
                selectedCourses.length > 0 && (
                  <div className="tab__contentBody">
                    <div className="tableWrap">
                      <div className="table-responsive">
                        <table className="table tableWrap__table">
                          <thead className="thead-light __appTheadColor">
                            <tr>
                              <th>Curriculum</th>
                              <th>Board</th>
                              <th>Stream</th>
                              <th>Class</th>
                              <th>Courses</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedCourses.map((entry, idx) => (
                              <tr key={idx}>
                                <td>{entry.curriculum?.name}</td>
                                <td>{entry.board?.name}</td>
                                <td>{entry.stream?.name}</td>
                                <td>{entry.class?.name}</td>
                                <td>{entry.courses.map((c) => c.label).join(', ')}</td>
                                <td>
                                  <AppButton
                                    onClick={() => handleDeleteSelectedCourse(idx)}
                                    className="actions-icons mx-2 text-danger"
                                  >
                                    <img src={AppPics.DeleteSvg} alt="delete" />
                                  </AppButton>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              <hr className="notification-divider" />
              <h3>Notification Content</h3>
              <div className="row mt-2">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <AppTextField
                    inputProps={{
                      value: title,
                      placeholder: 'notification title',
                      onChange: (event) => {
                        handleTitle(event.target.value);
                        clearFieldError('title');
                      },
                    }}
                    labelProps={{ label: 'Title *' }}
                    fieldErrors={errors['title']}
                  />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <AppTextField
                    inputProps={{
                      value: shortTitle,
                      placeholder: 'notification short title',
                      onChange: (event) => handleShortTitle(event.target.value),
                    }}
                    labelProps={{ label: 'Short Title' }}
                    fieldErrors={errors['shortTitle']}
                  />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <AppTextArea
                    label="Description"
                    areaProps={{
                      value: description,
                      placeholder: 'notification description',
                      onChange: (e) => handleDescription(e.target.value),
                      rows: 4,
                    }}
                    fieldErrors={errors['description']}
                  />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <AppUploadBlock
                    labelProps={{ label: 'Notification Image' }}
                    props={{
                      isImage: true,
                      isPublic: true,
                      referenceKey: 'ES_LOGO',
                      handleChange: (data = {}) => {
                        const { file, uploadedData } = data;
                        handleNotificationImageChange({ file, uploadedData });
                      },
                      fileData: {
                        fullPath: imageDeleted ? null : notificationImageFullPath,
                      },
                      clearFile: imageDeleted,
                      tabIndex: 3,
                    }}
                  />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <AppTextField
                    inputProps={{
                      value: toBeSendOn,
                      type: 'datetime-local',
                      onChange: (event) => handleToBeSendOn(event.target.value),
                    }}
                    labelProps={{ label: 'Send Date *' }}
                    fieldErrors={errors['toBeSendOn']}
                  />
                </div>
                {/* <div className="col-lg-4 col-md-6 col-sm-12">
                  <AppSelectBox
                    labelProps={{ label: 'Event *' }}
                    selectProps={{
                      value: event,
                      onChange: (event) => handleEvent(event.target.value),
                    }}
                    fieldErrors={errors['event']}
                  >
                    <option disabled value="">
                      Choose
                    </option>
                    <option value="general">General</option>
                    <option value="navigate">Navigate</option>
                    <option value="upgrade">Upgrade</option>
                  </AppSelectBox>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mt-2">
                  <AppTextField
                    inputProps={{
                      value: eventKey,
                      placeholder: 'notification event key',
                      onChange: (event) => handleEventKey(event.target.value),
                    }}
                    labelProps={{ label: 'Event Key' }}
                    fieldErrors={errors['eventKey']}
                  />
                </div> */}
              </div>
              <div className="row mt-4">
                <div className="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end">
                  <AppSwitchBox
                    labelProps={{ label: 'List Notification' }}
                    inputProps={{
                      checked: isListed,
                      onChange: (e) => {
                        setIsListed(e.target.checked);
                      },
                    }}
                  />
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-12 btnTab-foot">
                  <AppButton variantClass="btn-right-content save" onClick={handleFormSubmission}>
                    {isEditMode ? 'Update Notification' : 'Save Notification'}
                  </AppButton>
                </div>
              </div>

              <SelectCoursesModal
                open={isCourseModalOpen}
                onClose={() => setIsCourseModalOpen(false)}
                onConfirm={handleCourseModalConfirm}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

NotificationManageSection.defaultProps = {
  handleNotification: () => {},
};

const manageNotificationSchema = Joi.object({
  title: Joi.string().required().min(5),
  event: Joi.string().required(),
});

export default NotificationManageSection;
